module.exports = __webpack_public_path__ + "img/39.5d185cb6.svg";